import {
  formatJobPublishedDateDisplay,
  formatWorkModeDisplay,
  getJobCardSalaryLabel,
} from "../pages/applicantData";

function Pill({ label, value }) {
  const display = value != null && String(value).trim() !== "" ? String(value).trim() : "—";
  return (
    <span className="job-highlight-pill">
      <span className="job-highlight-pill__label">{label}</span>
      <span className="job-highlight-pill__value">{display}</span>
    </span>
  );
}

/** Compact highlight row for applicant home / latest-jobs list cards (search API job shape). */
export default function LatestJobsPreviewPills({ job, variant = "default" }) {
  if (!job) return null;
  const salary = getJobCardSalaryLabel(job);
  const functions = job.functionalArea || job.department || "";

  if (variant === "home") {
    return (
      <div className="job-highlights job-highlights--home">
        <Pill label="Published" value={formatJobPublishedDateDisplay(job)} />
        <Pill label="Salary" value={salary} />
        <Pill label="Location" value={job.location} />
        <Pill label="Job functions" value={functions} />
        <Pill label="Work mode" value={formatWorkModeDisplay(job.workMode)} />
      </div>
    );
  }

  return (
    <div className="job-highlights">
      <Pill label="Published" value={formatJobPublishedDateDisplay(job)} />
      <Pill label="Salary" value={salary} />
      <Pill label="Location" value={job.location} />
      <Pill label="Job functions" value={functions} />
      <Pill label="Work mode" value={formatWorkModeDisplay(job.workMode)} />
    </div>
  );
}
